export {CompactUredniDeskyProps} from './compact/compact.props';
export {TwoColumnUredniDeskyProps} from './two-column/two-column.props';
export {UredniDeskyCommonProps} from './uredni-desky-common.props';

export const name_two_column = "TwoColumnUredniDeskyComponent";
export const name_compact = "CompactUredniDeskyComponent";
